import  { SOLACE_PRICEING_DATA } from '../actions/getPricingInfoActions';

interface topicData {
	region:string,product_id:string,product_description:string,pricing:number,country:string,province:string
}
function updateObjectById(array:topicData[], product_id:string, topicNewData:topicData) {
	const index = array.findIndex(obj => obj['product_id'] === product_id);
	if (index !== -1) {
	  array[index] = { ...array[index], ...topicNewData };
	}else{
		array.push({ ...topicNewData,product_id });
	}
	return array;
  }

const getSolacePricingDataReducer = (
	state: {id:number , topic : string, topicData : any, page : number, rowsPerPage: number, pageOffset : number}[] = [
		{id:1, topic : '', topicData: [], page : 0, rowsPerPage: 25, pageOffset : 0 },
		{id:2, topic :'',  topicData: [], page : 0, rowsPerPage: 25, pageOffset : 0},
		{id:3, topic :'', topicData: [], page : 0, rowsPerPage: 25, pageOffset : 0}
	  ],
	action: any
): any => {
	switch (action.type) {
		case SOLACE_PRICEING_DATA:
			if(action.payload && action.payload.topicName && action.payload.topicData){
				return state.map((tE:{id:number , topic : string, topicData : any})=>{
					if(tE['topic']===action.payload.topicName){
						return {...tE,topicData : updateObjectById(tE['topicData'],action.payload.topicData['product_id'],action.payload.topicData)}
					}
					return tE;
				})
			}else{
                 return action.payload
			}
		default:
			return state;
	}
}

export default getSolacePricingDataReducer;